angular.module('gym.contacts').controller('SendMessageModalCtrl', ["$rootScope", "$scope", "$modalInstance", "$http", "flash", "DrawerService", "contactId", "messageType", "messageParams", function($rootScope, $scope, $modalInstance, $http, flash, DrawerService, contactId, messageType, messageParams) {
  var gym;
  $scope.gym = gym = $rootScope.gym;
  $scope.messageType = messageType;
  $scope.messageParams = messageParams;
  $scope.close = function() {
    return $modalInstance.dismiss('cancel');
  };
  $scope.requestClose = function() {
    return $scope.$emit('send_message:request_close');
  };
  $scope.reloadContact = function() {
    var url;
    url = `/gyms/${gym.id}/contacts/${contactId}`;
    return $http.get(url).then(function(response) {
      return $scope.contact = response.data;
    });
  };
  return $scope.reloadContact();
}]);
